// extracted by mini-css-extract-plugin
export default {"loader":"R2SYgO","load6":"_RW8I8","medium":"rR_y3e","mini":"ezdWoN"};